import {newRequest} from '@/utils/request'

// 列表
export const list = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/router/querylist', params)

// 新增
export const add = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/router/add', params)

// 修改
export const update = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/router/update', params)

// 详情
export const details = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/router/query', params)

// 删除
export const Delete = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/router/delete', params)
